import React, { useEffect, useMemo, useState } from "react";
import LanguageSelector from "../../../LanguageSelector/languageselector";
import "./uppernavbaragent.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { HOTELSRIVER_OFFICIAL_LOGO_URL as Logo } from "../../../../utils/hotelsRiverBrandLogo";
import { getUserInfo } from "../../../../services/localStorage";
import Tooltip from "@mui/material/Tooltip";
import { FaBars } from "react-icons/fa";
import homeIcon from "../../../../assets/images/navbar/home.png";
import bankNoteIcon from "../../../../assets/images/navbar/banknotes.png";
import reportIcon from "../../../../assets/images/navbar/report.png";
import academyIcon from "../../../../assets/images/navbar/mortarboard.png";
import searchIcon from "../../../../assets/images/navbar/search.png";
import graphIcon from "../../../../assets/images/navbar/graph.png";
import settingsIcon from "../../../../assets/images/navbar/settings.svg";
import ordersIcon from "../../../../assets/images/navbar/orders.png";
import ChangeUser from "../../../../assets/images/icons/change-user.png";
import CrmLeadOfferSearchBanner from "../../../../Pages/Agent/Crm/CrmLeadOfferSearchBanner";
import {
  isAdminUser,
  logout,
  getUserDetails,
  getSessionId,
  resolveSessionAgentId,
} from "../../../../services/authService";
import { getCustomerLinks } from "../../../../services/fhpService";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../../../contexts/AppContext";
import {
  HOTELS,
  PACKAGES,
  DYNAMIC_PACKAGES,
  useSearch,
} from "../../../../contexts/SearchContext";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import {
  useRemindersHub,
} from "../../../../features/reminders/context/RemindersHubContext";
import CurrencyRatesBar from "../../../CurrencyRatesBar/CurrencyRatesBar";
import { Badge as AntdBadge } from "antd";
import { fetchAgentPublicLeads } from "../../../../services/publicSiteLeadsApi";
import { countNewCrmProspectLeads } from "../../../../Pages/Agent/Crm/crmLeadFormatters";
import { CRM_HUB_ADMIN_ONLY } from "../../../../utils/crmHubFlag";
import { useCrmHubEnabled } from "../../../../utils/useCrmHubEnabled";
import { normalizeAgentImageValue } from "../../../../utils/resolveAgentCompanyLogoUrl";
import { useAgentEntitlements } from "../../../../features/agentEntitlements/useAgentEntitlements";
import {
  FileTextOutlined,
  BellOutlined,
  CommentOutlined,
  MessageOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { IoBoat } from "react-icons/io5";
import { buildCrmOpsDocketPath } from "../../../../Pages/Agent/Crm/navigateToCrmOpsDocket";

const getDraftCount = () => {
  try {
    const raw = localStorage.getItem("agent_drafts");
    if (!raw) return 0;
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.length;
    if (parsed && typeof parsed === "object") {
      if (Array.isArray(parsed.drafts)) return parsed.drafts.length;
      if (Array.isArray(parsed.items)) return parsed.items.length;
      if (typeof parsed.length === "number") return parsed.length;
    }
    return 0;
  } catch {
    return 0;
  }
};

const UpperNavBarAgent = ({ sideBarOpen }) => {
  const { isMobile, currencyRate, adminFocusMode, setAdminFocusMode } = useAppContext();
  const {
    canUseLeadsSystem,
    canUseManoQuotes,
    status: entitlementsStatus,
  } = useAgentEntitlements();
  const crmHubEnabled = useCrmHubEnabled();
  const { switchFromOrganizedToursIfNeeded, loading: searchResultsLoading } =
    useSearch();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isRTL = (i18n.language || "he") === "he";
  const user = getUserDetails();
  const pathNorm = location.pathname.replace(/\/+$/, "") || "/";
  const isDashboardHome =
    pathNorm === "/p/dashboard/home" || pathNorm === "/p/dashboard";
  const { companylogobase65 } = getUserInfo() || {};
  const agentNavbarLogoSrc = useMemo(
    () => normalizeAgentImageValue(companylogobase65) || Logo,
    [companylogobase65]
  );
  const isAdmin = isAdminUser();
  const [open, setOpen] = React.useState(false);
  const [draftCount, setDraftCount] = useState(0);
  const [offersCount, setOffersCount] = useState(0);
  const [newLeadsCount, setNewLeadsCount] = useState(0);
  const { summary } = useRemindersHub();

  const isAdminDashboardArea = location.pathname.includes("/p/dashboard/admin");
  const mainSidebarHiddenForAdminFocus = adminFocusMode && isAdminDashboardArea;
  // Must match CSS: .SideNav-wrapper { display: none } at max-width: 1024px
  const AGENT_DRAWER_MAX_PX = 1024;
  const [isDrawerBreakpoint, setIsDrawerBreakpoint] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia(`(max-width: ${AGENT_DRAWER_MAX_PX}px)`).matches
  );
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${AGENT_DRAWER_MAX_PX}px)`);
    const onChange = () => setIsDrawerBreakpoint(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  const sideBarMargin =
    mainSidebarHiddenForAdminFocus || isDrawerBreakpoint
      ? "0px"
      : sideBarOpen
        ? "250px"
        : "65px";

  const isSearch = window.location.pathname.includes("searchoffer");

  const adminMenuItems = isSearch
    ? [
        { text: t("sidenav.admin"), img: graphIcon, path: "admin" },
        {
          text: t("priceoffer.editclientsinfo"),
          img: ChangeUser,
          path: "searchoffer?clearuser=true",
        },
      ]
    : [
        { text: t("sidenav.admin"), img: graphIcon, path: "admin" },
      ];

  const logoutAgent = () => {
    logout();
    window.location.href = "/login";
  };

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [open]);

  useEffect(() => {
    const updateDraftCount = () => setDraftCount(getDraftCount());
    updateDraftCount();
    const handleStorageChange = (e) => {
      if (e.key === "agent_drafts" || !e.key) updateDraftCount();
    };
    window.addEventListener("storage", handleStorageChange);
    const handleDraftUpdate = () => updateDraftCount();
    window.addEventListener("draftUpdated", handleDraftUpdate);
    const interval = setInterval(updateDraftCount, 2000);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("draftUpdated", handleDraftUpdate);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    let cancelled = false;
    const fetchOffersCount = async () => {
      try {
        if (
          location.pathname.includes("searchoffer") &&
          searchResultsLoading
        ) {
          return;
        }
        const sessionID = await getSessionId();
        if (!sessionID) return;
        const response = await getCustomerLinks({
          sessionID,
          agent_id: isAdmin ? null : user?.id,
          limit: 1,
          offset: 0,
        });
        if (cancelled) return;
        const total = response?.data?.total_count;
        const n = typeof total === "number" ? total : parseInt(total, 10);
        if (!Number.isNaN(n) && n >= 0) setOffersCount(n);
      } catch {
        if (!cancelled) setOffersCount(0);
      }
    };
    fetchOffersCount();
    const interval = setInterval(fetchOffersCount, 60000);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [isAdmin, user?.id, location.pathname, searchResultsLoading]);

  useEffect(() => {
    if (entitlementsStatus !== "ok" || !canUseLeadsSystem) {
      setNewLeadsCount(0);
      return;
    }
    let cancelled = false;
    // Unassigned pool only (not /summary): new prospect leads with no agent.
    // Admins use scope=all so Meta / Facebook Lead Ads in the admin pool are included.
    const fetchNewLeadsCount = async () => {
      try {
        const res = await fetchAgentPublicLeads({
          limit: 100,
          scope: isAdmin ? "all" : undefined,
        });
        if (!res?.success) {
          if (!cancelled) setNewLeadsCount(0);
          return;
        }
        const next = countNewCrmProspectLeads(
          Array.isArray(res?.leads) ? res.leads : []
        );
        if (!cancelled) {
          setNewLeadsCount(Number.isFinite(next) && next > 0 ? Math.floor(next) : 0);
        }
      } catch {
        if (!cancelled) setNewLeadsCount(0);
      }
    };
    fetchNewLeadsCount();
    const interval = setInterval(fetchNewLeadsCount, 60000);
    const refreshHandler = () => fetchNewLeadsCount();
    window.addEventListener("publicLeadsStatusChanged", refreshHandler);
    return () => {
      cancelled = true;
      clearInterval(interval);
      window.removeEventListener("publicLeadsStatusChanged", refreshHandler);
    };
  }, [canUseLeadsSystem, entitlementsStatus, isAdmin]);

  // Untreated prospect leads — same count as CRM Hub "לידים" chip; always show when entitled.
  const showLeadsBadge =
    entitlementsStatus === "ok" && Boolean(canUseLeadsSystem);

  const leadsBellLabel = useMemo(() => {
    if (!showLeadsBadge) return "";
    if (isMobile) return newLeadsCount > 99 ? "99+" : String(newLeadsCount);
    if (newLeadsCount === 0) return "0 לידים חדשים";
    if (newLeadsCount === 1) return "ליד חדש";
    return `${newLeadsCount} לידים חדשים`;
  }, [isMobile, newLeadsCount, showLeadsBadge]);

  const leadsAriaLabel = useMemo(() => {
    if (!showLeadsBadge) return "";
    if (newLeadsCount === 0) return "0 לידים חדשים";
    if (newLeadsCount === 1) return "ליד חדש";
    return `${newLeadsCount} לידים חדשים`;
  }, [newLeadsCount, showLeadsBadge]);

  const sessionAgentId = resolveSessionAgentId(user);
  const hasAgentSession =
    sessionAgentId != null && String(sessionAgentId).trim() !== "";
  const operationUnreadAgent = Number(summary?.operation_unread_agent) || 0;
  const operationUnreadAdmin = Number(summary?.operation_unread_admin) || 0;
  const operationUnreadTotal = Number(summary?.operation_unread) || 0;
  const operationFirstUnread = summary?.operation_first_unread || null;
  const hasOperationFirstUnread = Boolean(
    String(operationFirstUnread?.id || "").trim()
  );
  // Any ops signal from RemindersHub — never treat as "system messages only".
  const operationUnread =
    operationUnreadTotal ||
    operationUnreadAgent + operationUnreadAdmin ||
    (hasOperationFirstUnread ? 1 : 0) ||
    0;
  const hasOperationUnread =
    operationUnreadAgent > 0 ||
    operationUnreadAdmin > 0 ||
    operationUnreadTotal > 0 ||
    hasOperationFirstUnread;
  // Dual-role admins: prefer agent ops chat when they have unread ops→agent replies
  // (or a deep-link target), not only when the aggregated total is non-zero.
  const preferAgentOpsBell =
    operationUnreadAgent > 0 ||
    hasOperationFirstUnread ||
    (!isAdmin && hasOperationUnread);
  const hasSystemFeedUnread =
    (Number(summary?.admin_feed_unread) || 0) > 0 ||
    (Number(summary?.personal_open) || 0) > 0;
  const opsBellLabel = useMemo(() => {
    if (!hasOperationUnread) return "";
    const countForLabel = preferAgentOpsBell
      ? operationUnreadAgent || operationUnread
      : isAdmin
        ? operationUnreadAdmin || operationUnread
        : operationUnread;
    if (isMobile) {
      return countForLabel > 99 ? "99+" : String(countForLabel);
    }
    if (preferAgentOpsBell || !isAdmin) {
      if (countForLabel === 1) return "התקבלה תשובה מאופרציה";
      return `${countForLabel} תשובות מאופרציה`;
    }
    if (countForLabel === 1) return "התקבלה הודעה חדשה";
    return `${countForLabel} הודעות חדשות`;
  }, [
    hasOperationUnread,
    isAdmin,
    isMobile,
    operationUnread,
    operationUnreadAdmin,
    operationUnreadAgent,
    preferAgentOpsBell,
  ]);

  const bellTooltip = hasOperationUnread
    ? opsBellLabel || "התקבלה הודעה חדשה"
    : hasSystemFeedUnread
      ? "הודעות מערכת"
      : hasAgentSession
        ? "הודעות אופרציה"
        : "הודעות מערכת";
  const bellAriaLabel = bellTooltip;

  const isNavItemActive = (path) => {
    const base = String(path).split("?")[0];
    if (base === "home") {
      const p = location.pathname.replace(/\/+$/, "") || "/";
      return p === "/p/dashboard/home" || p === "/p/dashboard";
    }
    return (
      location.pathname.includes(`/p/dashboard/${base}`) ||
      (base === "searchoffer" && location.pathname.includes("searchoffer"))
    );
  };

  const menuItems = [
    { text: t("sidenav.home"), img: homeIcon, path: "home" },
    {
      text: t("sidenav.academy"),
      img: academyIcon,
      path: "academy",
      isProminent: true,
    },
    { text: t("sidenav.searchoffer"), img: searchIcon, path: "searchoffer" },
    { text: t("sidenav.orders"), img: ordersIcon, path: "orders" },
    {
      text: "הודעות מערכת",
      icon: BellOutlined,
      path: "reminders",
    },
    {
      text: crmHubEnabled ? "CRM — לידים, הצעות ודוקטים" : "טיוטות והצעות בהליך",
      icon: FileTextOutlined,
      path: "drafts",
    },
    ...(canUseManoQuotes
      ? [
          {
            text: "הצעות מנו",
            icon: IoBoat,
            path: "mano-quotes",
          },
        ]
      : []),
    { text: t("sidenav.finance"), img: bankNoteIcon, path: "finance" },
    { text: t("sidenav.management"), img: settingsIcon, path: "management" },
    {
      text: t("sidenav.customers"),
      icon: TeamOutlined,
      path: "customers",
    },
    ...(!CRM_HUB_ADMIN_ONLY || isAdmin
      ? [
          {
            text: "לידים AI",
            icon: CommentOutlined,
            path: crmHubEnabled ? "drafts?tab=leads" : "ai-sales-leads",
          },
        ]
      : []),
    {
      text: "צ'אט לקוחות",
      icon: MessageOutlined,
      path: "customer-chat-inbox",
    },
    {
      text: t("sidenav.reports"),
      img: reportIcon,
      path: "reports",
    },
    ...(isAdmin ? adminMenuItems : []),
  ];

  const navigateToMenuPath = (path, isExternal) => {
    if (isExternal) {
      navigate(`/${path}`);
      return;
    }
    const base = String(path).split("?")[0];
    let searchProductTab = null;
    if (base === "searchhotels") searchProductTab = HOTELS;
    else if (base === "searchdynamic") searchProductTab = DYNAMIC_PACKAGES;
    else if (base === "searchpackages" || base === "searchoffer") searchProductTab = PACKAGES;
    if (searchProductTab) {
      switchFromOrganizedToursIfNeeded(searchProductTab);
    }
    const adminStem = String(path).split("?")[0];
    if (adminStem === "admin" || adminStem.startsWith("admin/")) {
      setAdminFocusMode(true);
    }
    navigate(`/p/dashboard/${path}`);
  };

  const canShowControls = isSearch && !isMobile;
  const navigateToReminders = (event) => {
    event.stopPropagation();
    navigate("/p/dashboard/remindes");
  };

  /** CRM dockets Ops pane (optional deep-link to first unread request). */
  const navigateToAgentOpsChat = () => {
    const first = operationFirstUnread;
    const rid = String(first?.id || "").trim();
    const oid = String(first?.orderId || first?.order_id || "").trim();
    const opsType = String(
      first?.requestType || first?.request_type || ""
    ).trim();
    navigate(
      buildCrmOpsDocketPath({
        orderId: oid || undefined,
        opsType: opsType || undefined,
        requestId: rid || undefined,
      })
    );
  };

  /**
   * Ops destination only — used by the ops label badge so it never falls through
   * to /remindes (הודעות מערכת).
   * Agent unread / non-admin → CRM dockets Ops; pure admin-inbox unread → admin inbox.
   */
  const navigateToOpsBellTarget = (event) => {
    event.stopPropagation();
    if (preferAgentOpsBell || !isAdmin) {
      navigateToAgentOpsChat();
      return;
    }
    navigate("/p/dashboard/admin/operation-requests");
  };

  const navigateToBellTarget = (event) => {
    event.stopPropagation();
    // 1) Any ops unread / first-unread → ops (never system messages).
    if (hasOperationUnread) {
      navigateToOpsBellTarget(event);
      return;
    }
    // 2) System broadcast / personal reminders only → הודעות מערכת.
    if (hasSystemFeedUnread) {
      navigateToReminders(event);
      return;
    }
    // 3) Nothing unread: agents + dual-role open Ops CRM (menu still has
    //    "הודעות מערכת"). Pure admin without agent session → reminders.
    if (hasAgentSession) {
      navigateToAgentOpsChat();
      return;
    }
    navigateToReminders(event);
  };

  const navigateToLeads = (event) => {
    event.stopPropagation();
    if (crmHubEnabled) {
      navigate("/p/dashboard/drafts?tab=leads");
      return;
    }
    navigate("/p/dashboard/ai-sales-leads");
  };

  return (
    <>
      <div
        className={`upper-nav-bar-agent-wrapper${isDashboardHome ? " upper-nav-bar-agent-wrapper--dashboard-home" : ""}`}
        style={{
          minHeight: "60px",
          "--agent-sidebar-inset": sideBarMargin,
        }}
      >
        <div className="right-side">
          <button className="open-drawer-button" onClick={() => setOpen(!open)}>
            <FaBars />
          </button>
          <Tooltip title={bellTooltip}>
            <div className="top-nav-bell-area">
              <IconButton
                size="small"
                aria-label={bellAriaLabel}
                onClick={navigateToBellTarget}
                sx={{ color: "inherit" }}
              >
                <Badge
                  badgeContent={summary.badge_total > 0 ? summary.badge_total : 0}
                  color="error"
                  max={99}
                  invisible={!summary.badge_total}
                >
                  <NotificationsNoneOutlinedIcon />
                </Badge>
              </IconButton>
              {hasOperationUnread && (
                <button
                  type="button"
                  className="top-nav-ops-msg-badge"
                  onClick={navigateToOpsBellTarget}
                  aria-label={bellAriaLabel}
                >
                  {opsBellLabel}
                </button>
              )}
              {showLeadsBadge && (
                <button
                  type="button"
                  className={`top-nav-leads-badge${
                    newLeadsCount === 0 ? " top-nav-leads-badge--zero" : ""
                  }`}
                  onClick={navigateToLeads}
                  aria-label={leadsAriaLabel}
                >
                  {leadsBellLabel}
                </button>
              )}
            </div>
          </Tooltip>
          <LanguageSelector />
          {/* <PhoneLine /> */}
          {!isMobile && currencyRate && !isDashboardHome && (
            <CurrencyRatesBar currencyRate={currencyRate} compact />
          )}
        </div>

        {!isMobile ? (
          <div className="logo-date-wrapper">
            <Tooltip title="לחץ למעבר לעמוד הראשי">
              <div className="agent-navbar-logo-box">
                <img
                  className="logo-img"
                  src={agentNavbarLogoSrc}
                  alt="לוגו"
                  width={180}
                  height={48}
                  decoding="async"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/p/dashboard/home`)}
                />
              </div>
            </Tooltip>
          </div>
        ) : (
          <div className="mobile-navbar-logo-left">
            <Tooltip title="לחץ למעבר לעמוד הראשי">
              <div className="agent-navbar-logo-box agent-navbar-logo-box--mobile">
                <img
                  className="mobile-navbar-logo-img"
                  src={agentNavbarLogoSrc}
                  alt="לוגו"
                  width={140}
                  height={40}
                  decoding="async"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/p/dashboard/home`)}
                />
              </div>
            </Tooltip>
          </div>
        )}
      </div>

      <CrmLeadOfferSearchBanner sideBarMargin={sideBarMargin} />

      <div className={"menu" + (open ? " open" : "")}>
        {currencyRate && (
          <CurrencyRatesBar currencyRate={currencyRate} variant="menu" />
        )}
        {menuItems.map((item, index) => {
          const IconComponent = item.icon;
          const active = isNavItemActive(item.path);
          const draftsBadge =
            item.path === "drafts" && (offersCount > 0 || draftCount > 0)
              ? offersCount > 0
                ? offersCount
                : draftCount
              : 0;
          return (
            <Tooltip
              key={index}
              title={item.disabled ? t("notifications.soon") : undefined}
              sx={{
                fontSize: "6.2rem",
                "& .MuiTooltip-tooltip": {
                  padding: "10px 15px",
                },
              }}
            >
              <div
                className={`menu-item ${item.disabled ? "disabled" : ""} ${item.isProminent ? "prominent-menu-item" : ""} ${active ? "active-menu-item" : ""}`}
                data-rtl={isRTL ? "true" : "false"}
                onClick={() => {
                  if (item.disabled) return;
                  navigateToMenuPath(item.path, item.isExternal);
                  setOpen(false);
                }}
              >
                <div className="menu-item-icon">
                  {IconComponent ? (
                    draftsBadge > 0 ? (
                      <AntdBadge
                        count={draftsBadge}
                        overflowCount={999}
                        size="small"
                        offset={isRTL ? [-4, -8] : [4, -8]}
                      >
                        <IconComponent style={{ fontSize: "22px" }} />
                      </AntdBadge>
                    ) : (
                      <IconComponent style={{ fontSize: "22px" }} />
                    )
                  ) : (
                    <img src={item.img} alt="" />
                  )}
                </div>
                <span>{item.text}</span>
              </div>
            </Tooltip>
          );
        })}
        <div
          className="mobile-logout-button"
          onClick={logoutAgent}
        >
          <span>{t("sidenav.logout")}</span>
        </div>
      </div>
    </>
  );
};

export default UpperNavBarAgent;
